import { Icon } from "components";
import { DOWNLOAD, FILETEXT } from "icons";
import { Button } from "ui/components/button";
import { assetUrl } from "utils/index";

export const IMAGE_TYPES = [
    "image/svg+xml",
    "image/png",
    "image/jpeg",
    "image/gif",
    "image/webp",
    "image/*",
];

export const handleDownload = async (fileId, title) => {
    try {
        const imageUrl = assetUrl(fileId);
        const response = await fetch(imageUrl, {
            credentials: "include",
        });

        if (!response.ok) {
            throw new Error("Failed to download image");
        }

        const blob = await response.blob();
        const url = URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        const extension = blob.type.split("/")[1] || "jpg";
        const filename = title
            ? `${title}.${extension}`
            : `asset-${fileId}.${extension}`;

        link.download = filename;
        document.body.appendChild(link);
        link.click();
        link.remove();
        URL.revokeObjectURL(url);
    } catch (error) {
        console.error("Error downloading image:", error);
    }
};

export function formatFileSize(bytes) {
    if (bytes === 0) return "0 Bytes";
    const k = 1024;
    const dm = 2;
    const sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return Number.parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + sizes[i];
};

export default function AssetsGridItem({ asset }) {
    if (!asset) return null;
    const extension = asset.type?.split("/")?.[1] || "file";
    const imageUrl = assetUrl(asset.id);
    const isImage = IMAGE_TYPES.some((type) => asset.type?.includes(type));
    return (
        <>
            <div key={asset.id} className="flex flex-col border border-border group">
                <div className="aspect-square bg-muted border-b border-border overflow-hidden flex items-center justify-center relative">
                    {isImage ? (
                        <img
                            src={imageUrl}
                            alt={asset.title}
                            className="size-full object-contain"
                            loading="lazy"
                        />
                    ) : (
                        <Icon icon={FILETEXT} className="size-18 mx-auto text-gray-500" />
                    )}
                    <Button
                        variant="ghost"
                        size="sm"
                        className="absolute bottom-0 inset-x-0 rounded-none cursor-pointer opacity-0 group-hover:opacity-100 transition-opacity duration-300 md:h-12"
                        onClick={() => handleDownload(asset.id, asset.title)}
                    >
                        <Icon icon={DOWNLOAD} className="size-4" />
                        Download
                    </Button>
                </div>

                <div className="p-2 border-border flex-1 text-sm">
                    <div className="md:text-lg font-medium truncate" title={asset.title}>{asset.title}</div>
                    <div className="flex items-center gap-1 text-sm line-clamp-1 text-muted-foreground font-medium">
                        <div className="text-xs uppercase">{extension}</div>
                        <span>•</span>
                        <div className="text-xs">{formatFileSize(Number(asset.filesize))}</div>
                    </div>
                </div>
            </div>
        </>
    );
}
